import { Fragment, useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../../models/calculation";

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsAdditionalOutage = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(-1);

    const handleActiveIndex = (index: number) =>
        activeIndex === index ? setActiveIndex(-1) : setActiveIndex(index);

    return (
        <Accordion id="accordion-CalcPropsAdditionalOutage-a">
            <Accordion.Title id={`accordionTitle-CalcPropsAdditionalOutage-a-${calculation.username}`} active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon id={`icon-CalcPropsAdditionalOutage-a-${calculation.username}`} name="dropdown" />
                Additional outage
            </Accordion.Title>
            <Accordion.Content id="accordionContent-CalcPropsAdditionalOutage-a" active={open}>
                <Accordion id="accordion-CalcPropsAdditionalOutage-b">
                    {calculation.additionalOutage.map((ao, i) => (
                        <Fragment  key={ao.branch.key}>
                            <Accordion.Title
                                id={`accordionTitle-CalcPropsAdditionalOutage-b-${i}`}
                                active={activeIndex === calculation.additionalOutage.indexOf(ao)}
                                index={calculation.additionalOutage.indexOf(ao)}
                                onClick={() =>
                                    handleActiveIndex(calculation.additionalOutage.indexOf(ao))
                                }
                            >
                                <Icon id={`icon-CalcPropsAdditionalOutage-b-${i}`} name="dropdown" />
                                <span id={`span-CalcPropsAdditionalOutage-b-${i}`}>{ao.branch.elementName}</span>
                            </Accordion.Title>
                            <Accordion.Content
                                id={`accordionContent-CalcPropsAdditionalOutage-c-${i}`}
                                active={activeIndex === calculation.additionalOutage.indexOf(ao)}
                            >
                                <p id={`p-CalcPropsAdditionalOutage-b-${i}`}>
                                    <span id={`span-CalcPropsAdditionalOutage-c-${i}`}>From: </span>
                                    {ao.branch.node1}
                                </p>
                                <p id={`p-CalcPropsAdditionalOutage-c-${i}`}>
                                    <span id={`span-CalcPropsAdditionalOutage-d-${i}`}>To: </span>
                                    {ao.branch.node2}
                                </p>
                                <p id={`p-CalcPropsAdditionalOutage-d-${i}`}>
                                    <span id={`span-CalcPropsAdditionalOutage-e-${i}`}>Order: </span>
                                    {ao.branch.orderCode}
                                </p>
                                <p id={`p-CalcPropsAdditionalOutage-e-${i}`}>
                                    <span id={`span-CalcPropsAdditionalOutage-f-${i}`}>Element name: </span>
                                    {ao.branch.elementName}
                                </p>
                                <p id={`p-CalcPropsAdditionalOutage-f-${i}`}>
                                    <span id={`span-CalcPropsAdditionalOutage-g-${i}`}>
                                        Timestamps:{" "}
                                        {ao.timestamps
                                            .map(x => x.toString().padStart(2, "0") + ":30")
                                            .join(", ")}
                                    </span>
                                </p>
                            </Accordion.Content>
                        </Fragment>
                    ))}
                </Accordion>
            </Accordion.Content>
        </Accordion>
    );
};
